import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { Quote, Star } from "lucide-react";

const Testimonials = () => {
  const { t } = useLang();

  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-14">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="lg:col-span-5"
          >
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="h-px w-8 bg-brand-red" />
              <span className="text-xs font-bold uppercase tracking-[0.22em] text-brand-red">
                {t.testimonials.eyebrow}
              </span>
            </div>
            <h2 className="font-heading font-black text-4xl sm:text-5xl tracking-[-0.02em] text-brand-navy leading-[1.05]">
              {t.testimonials.title}
            </h2>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="lg:col-span-7 lg:pt-2"
          >
            <p className="text-lg text-brand-navy/75 leading-relaxed">
              {t.testimonials.lead}
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.testimonials.items.map((it, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 60, scale: 0.95 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`testimonial-${i}`}
              className="relative rounded-3xl bg-brand-cream border border-brand-navy/10 p-7 sm:p-8 hover:shadow-[0_25px_50px_-20px_rgba(14,42,86,0.3)] hover:-translate-y-1 transition-all duration-300"
            >
              <Quote size={28} className="text-brand-red mb-5" />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} size={14} className="fill-brand-gold text-brand-gold" />
                ))}
              </div>
              <p className="text-base text-brand-navy/85 leading-relaxed font-medium">
                "{it.q}"
              </p>
              <div className="mt-6 pt-5 border-t border-brand-navy/10 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-brand-navy text-brand-cream flex items-center justify-center font-heading font-bold text-sm">
                  {it.n.charAt(0)}
                </div>
                <div>
                  <div className="font-heading font-bold text-brand-navy text-sm">{it.n}</div>
                  <div className="text-xs text-brand-navy/55 font-medium">{it.c}</div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
